import {
	Directive, 
	ElementRef,
	Renderer
} from '@angular/core';
import {
	Location
} from '@angular/common';
@Directive({
	selector: '[setActive]',
	host: {
		'(click)': 'onClick()',
	}
})

export class SetFocusDirective{

	constructor(private elem: ElementRef, private renderer: Renderer){

	}

	onClick(){
		this.renderer.setElementClass(this.elem, 'active', true);
	}
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/directives/set-focus.directive.ts